import { Dropdown } from 'tailwindcss-stimulus-components'

export default class extends Dropdown {
  static values = {
    ...Dropdown.values,
    exclusive: { type: Boolean, default: true },
    group: { type: String, default: 'default' },
    skipBeforeCache: { type: Boolean, default: false }
  }

  connect() {
    super.connect()
    this.handleDropdownOpen = this.handleDropdownOpen.bind(this)

    if (this.exclusiveValue) {
      document.addEventListener('dropdown:open', this.handleDropdownOpen)
    }
  }

  disconnect() {
    super.disconnect()

    if (this.exclusiveValue) {
      document.removeEventListener('dropdown:open', this.handleDropdownOpen)
    }
  }

  openValueChanged() {
    super.openValueChanged()

    if (this.openValue === true) {
      if (this.hasMenuItemTarget) {
        requestAnimationFrame(() => this.menuItemTargets[0].focus())
      }
      this.dispatch('open', { detail: { group: this.groupValue } })
    } else {
      this.dispatch('close', { detail: { group: this.groupValue } })
    }
  }

  handleDropdownOpen(event) {
    const { target, detail: { group } } = event

    if (target !== this.element &&
      group === this.groupValue &&
      this.openValue) {
      this.close()
    }
  }

  // This is overwritten from the parent class to prevent transitions
  get transitionOptions() {
    return {
      ...super.transitionOptions,
      enter: '',
      enterFrom: '',
      enterTo: '',
      leave: '',
      leaveFrom: '',
      leaveTo: ''
    }
  }

  beforeCache() {
    if (this.skipBeforeCacheValue) {
      return
    } 

    super.beforeCache()
  }
}
